@import '../../assets/fontawesome/css/all.min.css';

:host {
    display:inline-block;
}

i {
    display:block;
}